import { moveNext } from './workflow';
import { getNextRailResultsApi } from '../../services/api/search.service';
import { updateRailMatrix } from '../../utils/filter.utils';
import { selectActiveComponentIndex, selectSearchInput } from '../selectors/search.selector';
import { selectAccessToken } from '../selectors/auth.selector';
import to from '../../utils/to';
import i18n from '../../i18n';
import { openAlert } from './alert';
import { logException } from '../../utils/logger.utils';
import * as RootNavigation from '../../utils/navigationRef';

export const RAIL_SET_SORT = 'RAIL_SET_SORT';
export const SELECT_RAIL = 'SELECT_RAIL';
export const SET_RAIL_RESULTS = 'SET_RAIL_RESULTS';
export const RAIL_FILTER_BRAND = 'RAIL_FILTER_BRAND';
export const RAIL_APPLIED_FILTERS = 'RAIL_APPLIED_FILTERS';
export const RAIL_APPLIED_TIME_MATRIX_FILTER = 'RAIL_APPLIED_TIME_MATRIX_FILTER';

export const setRailResults = (displayIndex, railResponses) => {
  let searchResults;
  let brandList;
  let railTimeMatrixFilterBy = '';
  let filterTimeMatrixList;
  const vendorGroups = {};
  const vendors = {};
  const filterByDetails = {};
  const railResponsesParsed = JSON.parse(railResponses);
  if (railResponsesParsed.statusCode === 200) {
    searchResults = railResponsesParsed.body.result;
    searchResults.Responses = updateTimeMatrix(searchResults.Responses);
    brandList = getUniqueBrandList(railResponsesParsed.body.result);
    vendorGroups.items = getVendors(railResponsesParsed.body.result.RailVendors);
    vendors.vendorGroups = vendorGroups;
    filterByDetails.vendors = vendors;
    railTimeMatrixFilterBy = 'ALL';
    filterTimeMatrixList = updateRailMatrix(searchResults.Responses);
  }

  return {
    type: SET_RAIL_RESULTS,
    searchResults,
    brandList,
    filterByDetails,
    railTimeMatrixFilterBy,
    filterTimeMatrixList,
    displayIndex,
  };
};

export const railSetOrderBy = (sort, asc) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    dispatch({ type: RAIL_SET_SORT, sort, asc, displayIndex });
  };
};

export const selectRail = (selectedRail, classFare) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    dispatch({
      type: SELECT_RAIL,
      selectedRail,
      classFare,
      displayIndex,
    });

    dispatch(moveNext());
  };
};

export const filterRailResultsByBrand = (key) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    dispatch({ type: RAIL_FILTER_BRAND, key, displayIndex });
  };
};

export const filterByVendor = (filterByDetails) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    dispatch({ type: RAIL_APPLIED_FILTERS, filterByDetails, displayIndex });
  };
};

export const filterTimeMatrixByType = (selectedTimeMatrix) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    dispatch({ type: RAIL_APPLIED_TIME_MATRIX_FILTER, selectedTimeMatrix, displayIndex });
  };
};
export const getNextRailResults = () => {
  return async (dispatch, getState) => {
    const railRequestType = selectSearchInput(getState()).airRequestType;
    const displayIndex = selectActiveComponentIndex(getState());
    if (railRequestType === 2 && displayIndex > 1) {
      const accessToken = selectAccessToken(getState());
      //this is hard coded but shouldn't ever fail unless requirements change
      const selectedRail = getState().rail.components['1'].selectedRail;
      const selectedClassFare = getState().rail.components['1'].selectedClassFare;
      const search = getState().search;
      const { searchInput, tripResults } = search;
      const searchCriteria = searchInput.searchCriteria[0];
      const { adultCount, seniorcount, infants } = searchInput;
      const { fromCity, toCity, fromDate, toDate } = searchCriteria;
      const railRQ = {};
      railRQ.RequestKey = selectedRail.RequestId;
      railRQ.ResponseKeyLeg1 = selectedRail.Id;
      railRQ.MultiBrandKey = selectedClassFare.multiBrandID;
      railRQ.LegNumber = displayIndex;
      railRQ.RailRequestType = railRequestType;
      railRQ.IsRailV2 = true;
      railRQ.OfferIds = [selectedClassFare.offerId];
      railRQ.TravelRequestId = tripResults.TravelRequestId;
      const railTravelComponent = {
        DepartureStation: fromCity,
        ArrivalStation: toCity,
        FromDate: fromDate,
        ToDate: toDate,
        NoOfChildren: infants.length,
        NoOfAdults: adultCount,
        NoOfSeniors: seniorcount,
      };
      const [err, railResponse] = await to(
        getNextRailResultsApi(
          accessToken,
          JSON.stringify(railRQ),
          JSON.stringify(railTravelComponent)
        )
      );
      if (err) {
        dispatch(
          openAlert({
            title: i18n.t('RailSearchFailureMessage'),
            confirmText: i18n.t('GoBack'),
            onConfirmPressed: () => RootNavigation.goBack(),
          })
        );
        logException(err, { metaData: { requestKey: railRQ.RequestKey } });
      } else {
        dispatch(setRailResults(displayIndex, railResponse));
      }
    }
  };
};

const getUniqueBrandList = (railList) => {
  const multiBrandRail = [...new Set(railList.Responses.map((rail) => rail.multiBrandFare))];
  let lowestPrice = 0;
  const railBrandDict = {};
  for (let i = 0; i < multiBrandRail.length; i++) {
    const len = multiBrandRail[i].length;
    for (let j = 0; j < len; j++) {
      if (railBrandDict[multiBrandRail[i][j].brandName] !== undefined) {
        const price = multiBrandRail[i][j].totalPriceToDisplay;
        lowestPrice = price < lowestPrice || lowestPrice !== 0 ? price : lowestPrice;
        const currentPrice = railBrandDict[multiBrandRail[i][j].brandName];
        railBrandDict[multiBrandRail[i][j].brandName] = price < currentPrice ? price : currentPrice;
      } else {
        railBrandDict[multiBrandRail[i][j].brandName] = multiBrandRail[i][j].totalPriceToDisplay;
      }
    }
  }
  const railBrandList = [];
  Object.keys(railBrandDict).forEach(function (key) {
    railBrandList.push({
      icon: 'rail',
      key: key,
      brand: key,
      price: railBrandDict[key],
    });
  });

  lowestPrice = railBrandList.reduce(function (prev, curr) {
    return prev.price < curr.price ? prev : curr;
  });

  railBrandList.unshift({
    icon: 'rail',
    key: 'Lowest',
    brand: 'Lowest',
    price: lowestPrice.price,
  });

  return railBrandList;
};

const getVendors = (vendorsRS) => {
  const item = {};
  for (let i = 0; i < vendorsRS.length; i++) {
    item[vendorsRS[i].Vendor] = {
      name: vendorsRS[i].Vendor,
      price: vendorsRS[i].VendorLowestPrice,
      checked: true,
    };
  }
  return item;
};

const updateTimeMatrix = (railList) => {
  for (let i = 0; i < railList.length; i++) {
    railList[i].price = railList[i].amountToDisplay;
    railList[i].filterDepart = parseInt(
      railList[i].departureTime.replace(':', '').replace(':', '')
    );
    railList[i].filterArrival = parseInt(railList[i].arrivalTime.replace(':', '').replace(':', ''));
    railList[i].durationTime = parseInt(
      railList[i].duration.days * 24 +
        '' +
        railList[i].duration.hours +
        '' +
        railList[i].duration.minutes
    );
  }
  return railList;
};
